<template>
  <div class="trainer-advanced-filter tradvfer">
    <div class="tradvfer_top">
      <div class="tradvfer_drill">
        <div class="tradvfer_drill_name truncate">
          {{ selectedDrill.name || $t('common.new_drill') }}
        </div>
        <div
          v-if="!selectedDrill.public && selectedDrill.name"
          class="mdi mdi-pencil icon_btn csst text-nowrap text-semi-larges ma-auto ml-2 pa-1 line-height_1 clr-grey"
          @click="openPresetSaveDialog"
          @mouseenter="e => fl_positionTooltip(e, { placement: 'top' })"
        >
          <div
            class="csst_content clr-white"
            style="position: fixed"
          >
            {{ $t('tooltips.edit_drill_name') }}
          </div>
        </div>
      </div>
    </div>
    <div class="tradvfer_top_content">
      <TrainerAdvancedFilterOverview
        :namespace="tmpNamespace"
        :solElite="solElite"
      />
    </div>
    <div class="tradvfer_bottom">
      <TabsContentTemplate
        :sections="sections"
        :tab="defaultTab"
        style="--max-content-width: var(--max-tab-content-width)"
        @update:tab="
          tab => {
            if (tab === 'hands' && $refs.PulseCircle) {
              $refs.PulseCircle.close()
            }
          }
        "
      >
        <template #content_game>
          <TrainerStreetFilter
            class="tradvfer_right_item"
            :isCentered="false"
            :hasTable="false"
            :hasStreetTitle="true"
            :hSpotsCentered="false"
            :namespace="tmpNamespace"
            :hSpotsOpenToTop="false"
          >
            <template #main_before>
              <div class="f-column position-relative mr-auto">
                <div
                  class="clr-grey text-medium"
                  style="margin-bottom: 0.25rem"
                >
                  {{ $t('common.solutions') }}
                </div>

                <GmfSelektorBtn
                  data-tst="trainer_filter_gmfselektorbtn"
                  @click="openSolutionsDialog"
                >
                  <CustomFormatOption
                    v-if="solElite.want_use && (solElite.loading_what || solElite.cTree)"
                    :loading="solElite.loading_what"
                    :customTree="solElite.cTree"
                  />
                  <span
                    v-else
                    class="truncate text-center"
                    style="
                      line-height: 1.2;
                      max-width: calc(100vw - 5rem);
                      min-width: clamp(1px, 8rem, 100vw);
                    "
                    v-html="gmf.mainHtml"
                  ></span>
                  <template #dot>
                    <div
                      v-if="!solElite.want_use && gmf.listLength"
                      class="gmf-circle-list"
                    >
                      {{ gmf.listLength }}
                    </div>
                  </template>
                </GmfSelektorBtn>
              </div>
            </template>
          </TrainerStreetFilter>
        </template>
        <template #content_board>
          <TrainerBoardFilter
            class="tradvfer_right_item"
            :namespace="tmpNamespace"
          />
        </template>

        <template #content_hands>
          <TrainerCombosFilter
            class="tradvfer_right_item"
            :namespace="tmpNamespace"
          />
        </template>

        <template #content_modes>
          <TrainerPreferences
            style="
              --preff-clr-row-back: var(--clr-black-1-2);
              --preff-clr-btn-back: var(--clr-black-1-2);
            "
            class="tradvfer_right_item"
            :namespace="tmpNamespace"
            :canCloneSettings="false"
            :hiddenOptions="[
              'fh_trainer_quick_result',
              'fh_trainer_rng_visible',
              'fh_trainer_streak_visible',
              'fh_trainer_hero_frequency',
              'fh_trainer_hero_range',
              'fh_trainer_opponent_range',
              'fh_trainer_ranges_comparison',
              'fh_trainer_equity_chart',
              'fh_trainer_hand_strength',
              'fh_trainer_total_frequency',
              'fh_trainer_category_hands',
              'fh_trainer_category_draws',
              'fh_trainer_hero_strategy',
            ]"
          />
        </template>
        <template #content_display>
          <TrainerPreferences
            style="
              --preff-clr-row-back: var(--clr-black-1-2);
              --preff-clr-btn-back: var(--clr-black-1-2);
            "
            class="tradvfer_right_item"
            :namespace="tmpNamespace"
            :canCloneSettings="false"
            :hiddenOptions="[
              'fh_trainer_mode',
              'fh_trainer_learning_mode',
              'fh_trainer_game_speed',
              'fh_trainer_grouping',
              'fh_trainer_game_mode',
              'fh_rng',
              'fh_trainer_result',
              'fh_trainer_autoplay',
              'fh_trainer_session',
              'fh_trainer_tables',
              'fh_trainer_timebank',
            ]"
          />
        </template>
      </TabsContentTemplate>
    </div>
  </div>
</template>

<script>
import GmfSelektorBtn from '@/components/GameFormat/GmfSelektor/GmfSelektorBtn'
import CustomFormatOption from '@/components/GameFormat/CustomFormatOption'
import PulseCircle from '@/components/lib/PulseCircle'
import TrainerPreferences from '@/components/Trainer/TrainerPreferences'
import TrainerStreetFilter from '@/components/Trainer/TrainerStreetFilter'
import TrainerBoardFilter from '@/components/Trainer/TrainerBoardFilter'
import TrainerCombosFilter from '@/components/Trainer/TrainerCombosFilter'
import TrainerAdvancedFilterOverview from '@/components/Trainer/TrainerAdvancedFilterOverview'
import TabsContentTemplate from '@/components/TabsContentTemplate/TabsContentTemplate'
import { getGameformatOptionHtml } from '@/store/gameformat/gameformat'
import { getSetupParams } from '@/helpers/practice_trainer_calls'
import float_mix from '@/mixins/float_mix'

export default {
  name: 'TrainerAdvancedFilter',
  components: {
    TrainerPreferences,
    TrainerBoardFilter,
    TrainerAdvancedFilterOverview,
    TrainerCombosFilter,
    TrainerStreetFilter,
    TabsContentTemplate,
    GmfSelektorBtn,
    CustomFormatOption,
    PulseCircle,
  },
  mixins: [float_mix],
  props: {
    namespace: { String, required: true },
    tmpNamespace: { String, required: true },
    defaultTab: String,
  },
  data() {
    return {
      editTitle: false,
      nameError: false,
    }
  },
  created() {
    this.$store.dispatch('poker_copy_module', {
      from_namespace: this.namespace,
      to_namespace: this.tmpNamespace,
      queryGroup: 'trainer',
    })
    this.$store.dispatch('poker_update_module', {
      namespace: this.tmpNamespace,
      queryGroup: 'trainer_filter',
    })
    this.$store.dispatch('poker_copy_module', {
      from_namespace: this.namespace,
      to_namespace: this.tmpNamespace,
      queryGroup: 'router',
    })
    this.$store.dispatch('poker_copy_module', {
      from_namespace: this.namespace,
      to_namespace: this.tmpNamespace,
      queryGroup: 'router-to-gmf-selektor',
    })
  },
  methods: {
    apply() {
      this.$store.dispatch('poker_copy_module', {
        from_namespace: this.tmpNamespace,
        to_namespace: this.namespace,
        queryGroup: 'trainer',
      })
      this.$store.dispatch('poker_copy_module', {
        from_namespace: this.tmpNamespace,
        to_namespace: this.namespace,
        queryGroup: 'router-to-gmf-selektor',
      })

      const custom_solution = this.$store.getters.api_get(
        'api_poker_custom_solution',
        this.tmpNamespace,
      )
      const custom_solution_tree = this.$store.getters.api_get(
        'api_poker_custom_solution_tree',
        this.tmpNamespace,
      )

      this.$store.commit('api_update', {
        key: 'api_poker_custom_solution',
        result: custom_solution,
        replace: true,
        namespace: this.namespace,
      })
      this.$store.commit('api_update', {
        key: 'api_poker_custom_solution_tree',
        result: custom_solution_tree,
        replace: true,
        namespace: this.namespace,
      })
    },
    openPresetSaveDialog() {
      const dialog = `save-drill-dialog_namespace-${this.namespace}_tmpNamespace-${this.tmpNamespace}`
      this.$store.dispatch('router_set_dialogs', dialog)
    },
    openSolutionsDialog() {
      const tmpSecondaryNamespace = 'tmp/secondary'
      this.$store.dispatch('poker_copy_module', {
        from_namespace: this.tmpNamespace,
        to_namespace: tmpSecondaryNamespace,
        queryGroup: 'trainer',
      })
      this.$store.dispatch('poker_copy_module', {
        from_namespace: this.tmpNamespace,
        to_namespace: tmpSecondaryNamespace,
        queryGroup: 'router-to-gmf-selektor',
      })
      const dialog = `solutions-dialog_namespace-${this.tmpNamespace}_tmpNamespace-${tmpSecondaryNamespace}`
      this.$store.dispatch('router_set_dialogs', dialog)
    },
  },
  computed: {
    gmf() {
      const nn = this.tmpNamespace
      const ssp = getSetupParams({
        namespace: nn,
        rootGetters: this.$store.getters,
        last_hand_query: null,
      })
      const customSpot = this.$store.getters[`${nn}/router_query`].fh_start_spot === 'custom_spot'
      let gmf = this.$store.getters[`${nn}/gameformat`]
      const gmfWithMostPlayers = this.$store.getters[`${nn}/gmfs_gmfWithMostPlayers`]
      if (!customSpot) {
        gmf = gmfWithMostPlayers || gmf
      }

      let listLength =
        (ssp.depth_list?.length || 0) +
        (ssp.stacks_list?.length || 0) +
        (ssp.average_stack?.length || 0)

      const gametype_list = ssp.gametype_list || []
      listLength = listLength === 1 ? 0 : listLength
      const showStackDepth = customSpot ? true : listLength === 0 && gametype_list.length <= 1
      const mainHtml = getGameformatOptionHtml({
        gameformat: gmf,
        // gametype_list,
        omitKeys: !showStackDepth
          ? [
              'depth',
              'stacks',
              'avg_stacks',
              'type_opening_size',
              '_3bet_size',
              'tournament_phase',
              'opening_type',
              'variant',
              'cash_drop',
            ]
          : ['cash69max_type'],
      })
      const res = {
        mainHtml,
        listLength,
      }
      return res
    },
    selectedDrill() {
      return this.$store.getters.drills_selected_drill
    },
    solElite() {
      return this.$store.getters[`${this.tmpNamespace}/sol_elite`]
    },
    startSpotCustom() {
      return (
        this.$store.getters[`${this.tmpNamespace}/router_query`].fh_start_spot === 'custom_spot'
      )
    },
    sections() {
      return [
        {
          id: 'game',
          title: this.$t('common.game'),
          icon: 'mdi-cards-spade-outline',
          tour: { tour: 'tra_advc_game' },
          cssStyle: '--z-index-title:6; --z-index-content:5',
        },
        {
          id: 'board',
          title: this.$t('common.board'),
          icon: 'mdi-cards-outline',
          tour: { tour: 'tra_advc_board' },
        },
        {
          id: 'hands',
          title: this.$t('common.hands'),
          icon: 'mdi-cards-playing-spade-outline',
          tour: { tour: 'tra_advc_hands' },
        },
        {
          id: 'modes',
          title: this.$t('common.modes'),
          icon: 'mdi-cog-outline',
          tour: { tour: 'tra_advc_modes' },
        },
        {
          id: 'display',
          title: this.$t('common.display'),
          icon: 'mdi-eye-outline',
          tour: { tour: 'tra_advc_display' },
        },
      ]
    },
  },
}
</script>
<style lang="scss" scoped>
.gmf-circle-list {
  position: absolute;
  border-radius: 99px;
  padding: 0.125rem 0.25rem;
  background: var(--clr-primary);
  top: -0.5rem;
  flex-shrink: 0;
  right: -0.5rem;
  font-size: 0.8rem;
  z-index: 1;
}
.tradvfer {
  display: flex;
  flex-direction: column;
  background: var(--clr-black-1);
  --width: 46rem;
  --max-tab-content-width: 37.5rem;
  min-width: var(--width);
  max-width: var(--width);
  min-height: 0;
  height: 100vh;
  max-height: 52rem;
  &_top {
    padding: 1rem 1rem 1rem 1rem;
    border-bottom: 1px solid var(--clr-black-3);
    display: flex;
    max-width: 100vw;
    justify-content: space-between;
    &_content {
      border-bottom: 1px solid var(--clr-black-3);
    }
  }
  &_drill {
    width: 100%;
    position: relative;
    padding: 0 1rem 0 0;
    display: flex;
    &_icon {
      font-size: 1.25rem;
      position: absolute;
      right: 0;
      bottom: 0;
      padding: 0.25rem;
    }
    &_name {
      font-weight: 500;
      color: var(--clr-primary);
      padding-left: 0.25rem;
      font-size: 1.25rem;
    }
    &_description {
      padding-left: 0.25rem;
      font-size: 0.8rem;
      width: 100%;
      color: var(--clr-grey-2);
      width: 100%;
    }
  }
  &_title {
    font-size: 1rem;
    text-transform: uppercase;
    color: var(--clr-grey-2);
    padding: 0 1rem;
    height: 2.5rem;
    background: var(--clr-black-2);
    font-weight: 500;
    align-items: center;
    display: flex;
    position: sticky;
    top: -1px;
    z-index: 4;
  }
  &_presets {
    display: flex;
    margin: auto 0 0.75rem auto;
    height: 2rem;
    flex-direction: column;
    position: relative;
    top: 0.25rem;
    &_title {
      position: absolute;
      color: var(--clr-grey-2);
      font-size: 0.8rem;
      top: -1.25rem;
      padding: 0 0.25rem;
    }
  }
  &_bottom {
    display: flex;
    flex: 1;
    min-height: 0;
  }
  &_right {
    &_item {
      padding: 1rem;
    }
  }
}

@media (max-width: 1023px) {
  .tradvfer {
    max-width: 100vw;
    max-height: unset;
    min-height: 0;
    --max-tab-content-width: 100vw;
    &_top {
      justify-content: flex-start;
    }
    &_drill {
      max-width: calc(100% - 4rem);
      &_input {
        width: 100%;
      }
    }
  }
}
</style>
